import React, { ReactNode } from 'react';

import * as S from './LoadingView.styles';

interface LoadingViewProps {
  loading?: boolean;
  className?: string;
  children?: ReactNode;
}

export const LoadingView = ({
  loading,
  children,
  className,
}: LoadingViewProps) =>
  loading ? (
    <S.Container data-testid="loading-view" className={className}>
      <S.Indicator />
    </S.Container>
  ) : (
    <>{children}</>
  );
